export default {
  methods: {
    addClass(className) {
      const element = document.getElementById(this.id);
      if (element) {
        let arr;
        arr = element.className.split(" ");
        if (arr.indexOf(className) == -1) {
          element.className += " " + className;
        }
      }
    },
    removeClass(className) {
      const element = document.getElementById(this.id);
      if (element) {
        element.className = element.className.replace(new RegExp(`\\b${className}\\b`), "");
      }
    },
    handleInput(e) {
      const value = e.target.value;
      this.$emit("input", value.length == 0 ? null : value);
      if (this.name && this.isRequired) {
        if (value.length === 0) {
          this.addClass('hasError');
          this.addClass('empty');
          this.removeClass('invalid');
        } else {
          this.removeClass('hasError');
          this.removeClass('empty');
          if (this.name === 'formEmail') {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
              this.removeClass('hasError');
              this.removeClass('invalid');
            } else {
              this.addClass('hasError');
              this.addClass('invalid');
            }
          }
          if (this.name === 'formPhone') {
            if (!isNaN(parseFloat(value)) && isFinite(value)) {
              this.removeClass('hasError');
              this.removeClass('invalid');
            } else {
              this.addClass('hasError');
              this.addClass('invalid');
            }
          }
        }
      }
    }
  }
};
